export default __webpack_public_path__ + "static/media/rzd.6d3d65d4.jpg";